export default "__VITE_ASSET__DIevhBCy__"